import { render, staticRenderFns } from "./u-pagination-text-circle.vue?vue&type=template&id=5d223066&scoped=true&"
import script from "./u-pagination-text-circle.vue?vue&type=script&lang=js&"
export * from "./u-pagination-text-circle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d223066",
  null
  
)

export default component.exports